import React, { useEffect, useState } from "react"
import { Alert, Label, Input } from "reactstrap"
import { useLocation } from "react-router-dom"
import { RedeemCodes } from "../../../../Code/Data"
import { parseQuerystring, scrollToElement } from "../../../../Code/Utilities"
import { useRedemptionData } from "../../../../Context/redemption"
import { useAppData } from "../../../../Context/appData"
import CharitySelector from "../../../Common/CharitySelector"
import { Button } from "../../../index"
import styles from "./styles.module.scss"

function Step2({ onBack, onContinue, setSuccess, codeAsEntered, charityId, multi, codes, rc, loggedInUser }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  //Whether or not the user wishes to share their information with the selected charities.
  const [shareInfoBool, setShareInfoBool] = useState(false)
  const {
    redemptionData,
    setRedemptionData,
    getRedeemCodeInfo,
    redeemCodeInfo,
  } = useRedemptionData()
  const { fullCharityList, loading: loadingAppData } = useAppData()
  const { Charities } = redemptionData
  const { charityList, setCharityList } = useState()
  const addToDonationAmount = (redeemCodeInfo?.AddedToDonationAmount || 0)
  const { search } = useLocation()
  const { HideAmountAllOrders } = loggedInUser || {}
  const [total, setTotal] = useState()
  const [isEditMode, setEditMode] = useState(false)
  const [catId, setCatId] = useState()
  const [catName, setCatName] = useState()

  useEffect(() => {
    const fetchData = async () => {
      if (multi && codes.length > 1) {
        let res = await getCodesSum()
        setTotal(res)
      }
      else {
        const amt = parseFloat(redeemCodeInfo?.AmountToRedeem)
        setTotal(Number.isFinite(amt) ? amt : undefined)
      }
    }
    fetchData()
    if (redemptionData?.Charities) setEditMode(true)
  }, [redeemCodeInfo, multi, codes])

  useEffect(() => {
    const doAutomaticRedeem = async () => {
      const { CharityId } = redeemCodeInfo
      const { CHARITYID, PRESELCHARID, CID } = parseQuerystring(window.location.search.toUpperCase())
      const preselectedCharityId = redeemCodeInfo?.PreSelectedCharityId || PRESELCHARID
      const charityToRedeemTo = fullCharityList?.find(
        c => [CharityId, parseInt(CHARITYID), parseInt(preselectedCharityId), parseInt(CID)].includes(c.CharityId)
      )

      if (charityToRedeemTo) {
        setRedemptionData({
          ...redemptionData,
          Charities: [charityToRedeemTo],
        })

        if (CharityId || CHARITYID) {
          await handleContinue(charityToRedeemTo)
        }
      }
    }
    doAutomaticRedeem()
  }, [search, loadingAppData])

  const handleCharityChosen = charity => {
    if (!Charities?.find(item => item === charity) && (Charities?.length ?? 0) < 3) {
      setRedemptionData({
        ...redemptionData, Charities: [...Charities, charity],
      })
    }
  }
  const getCodesSum = async () => {
    let sum = 0
    for (const code of codes) {
      try {
        const result = await getRedeemCodeInfo(code, loggedInUser.UserId)
        if (result && result?.AmountToRedeem) {
          sum += result.AmountToRedeem
        }
      } catch (error) {
        console.error("Error fetching redeem code info:", error)
      }
    }
    return sum
  }

  const handleRemoveCharity = charityId => () => {
    setRedemptionData({
      ...redemptionData, Charities: Charities.filter(({ CharityId }) => CharityId !== charityId),
    })
  }
  const handleSetShareInfo = () => {
    const value = !shareInfoBool
    setShareInfoBool(value)
    if (value === false) setRedemptionData(data => ({
      ...data,
      ShareInfo: {
        fName: "",
        lName: "",
        email: "",
      },
    }))
  }
  const afterAddCharity = () => {
    scrollToElement("#divCharityChosen", true, 0)
  }

  const handleChangeField = e => {
    const { id, value } = e.target
    setRedemptionData(data => ({
      ...data,
      ShareInfo: {
        ...data.ShareInfo,
        [id]: value,
      },
    }))
  }

  const handleContinue = async charity => {
    const payload = {
      RedeemCode: redemptionData.code,
      Charities: (charity && charity.CharityId
        ? [{ CharityId: charity.CharityId }]
        : Charities.map(c => ({ CharityId: c.CharityId }))),
      ShareRedeemerInfo: redemptionData.shareInfo,
      RedeemerInfo: redemptionData.shareInfo ?? (!!redemptionData?.email ? { Email: redemptionData?.email } : null)
    }
    setLoading(true)
    const { Succeeded, ErrorMessage } = await RedeemCodes(payload)
    setLoading(false)

    Succeeded ? setSuccess(true) : setError(ErrorMessage)
  }
  return (<div className={styles.container}>
    <div className={styles.charityChosen} id="divCharityChosen">
      <Alert color="danger" isOpen={!!error} toggle={() => setError()}>
        <div className={styles.errorWrapper}>{error}</div>
      </Alert>
      <div
        className={styles.lblCharity}>{Charities && Charities.length ? "Your selected " + (Charities.length > 1 ? "Charities" : "Charity") : "Please choose your charity"}</div>
      {Charities && Charities.length ? Charities.map(({ CharityId, LogoUrl, CharityName, CategoryName }, index) => (
        <div key={index} className={styles.preselectedCharity}>
          <div className={styles.itemImage}>
            {LogoUrl && <img src={LogoUrl} alt={CharityName} />}
            <div
              className={styles.btnRemove}
              onClick={handleRemoveCharity(CharityId)}>
              <i className="fa-solid fa-xmark" />
            </div>
          </div>
          <div className={styles.itemDetail}>
            <div className={styles.itemName}>{CharityName}</div>
            <div className={styles.itemDesc}>{CategoryName}</div>
          </div>
        </div>)) : null}
      {!HideAmountAllOrders && (!redeemCodeInfo?.HideAmount) && Number.isFinite(total) &&
        (<div className={styles.priceTotal}>
          {!!addToDonationAmount && !multi &&
            (<div className={styles.addtoDonationBreakdown}>
              Original Donation: ${(total - addToDonationAmount).toFixed(2)}
              <br />
              Added Amount: ${Number(addToDonationAmount).toFixed(2)}
            </div>)}
          <div>
            Total : ${total.toFixed(2)}
          </div>
          <p>* Amount will be split between the charities evenly.</p>
        </div>)}
      <Label check className={styles.shareContact}>
        <Input
          type="radio"
          checked={shareInfoBool === true}
          onChange={() => handleSetShareInfo()}
        />
        <span className={styles.lblTerms}>
          Please share my info with the charities I've selected!
        </span>
        {shareInfoBool && <>
          <div className={styles.shareInfoForm}>
            <input id={"fName"} className={styles.shareInfoInput} type={"text"} placeholder={"First Name"}
              value={redemptionData.ShareInfo.fName} onChange={(e) => handleChangeField(e)} />
            <input id={"lName"} className={styles.shareInfoInput} type={"text"} placeholder={"Last Name"}
              value={redemptionData.ShareInfo.lName} onChange={(e) => handleChangeField(e)} />
          </div>
          <div className={styles.shareInfoForm}>
            <input id={"email"} className={styles.shareInfoInput} type={"email"} placeholder={"Email"}
              value={redemptionData.ShareInfo.email} onChange={(e) => handleChangeField(e)} />
          </div>
        </>
        }
      </Label>
      <Button
        className={styles.btnContinue}
        disabled={!Charities.length}
        loading={loading}
        onClick={handleContinue}>
        {addToDonationAmount > 0 ? "Confirm and Check Out" : "Confirm Selections"}
      </Button>
      <button className={styles.btnStepBack} onClick={onBack}>
        Go Back
        <i className="fa fa-undo" />
      </button>
    </div>
    <div className={styles.selectCharity}>
      <div>
        <CharitySelector
          setSelCharityList={setCharityList}
          fromRedemption={true}
          charities={Charities || []}
          onUpdate={handleCharityChosen}
          afterAddCharity={afterAddCharity}
          catId={catId}
          catName={catName}
          handleChangeCat={(categoryId, categoryName) => {
            setCatId(categoryId)
            setCatName(categoryName)
          }}
          max={3} />
      </div>
    </div>
  </div>)
}

export default Step2
